class ConfigSingleton {
  constructor(initialData) {
    this.state = { ...initialData };
  }

  getConfig() {
    return this.state;
  }

  setConfig(config) {
    Object.entries(config).map(([key, value]) => {
      this.state[key] = value;
    });
  }
}
// added properties from .env file
const initialData = {
  REACT_APP_BASE_URL: 'https://precisa-beta.dev.finezza.in',
  REACT_APP_ENV: 'DEV',
  REACT_APP_GA_MEASUREMENT_ID: 'G-WEDC96K845',
  REACT_APP_GA_MEASUREMENT_ID_FOR_CONVERSION: 'G-974GH2XW81',
  USE_GA: 'YES',
  REACT_APP_TIMEOUT_M_S: 120000,
  REACT_APP_POSTMAN_CLIENT_ID: 'e1d6546f78ca474d8acc',
  REACT_APP_GOOGLE_CLIENT_ID:
    '861665766889-r9m4kjabipol9ensgv5kdq7eqp8p02qe.apps.googleusercontent.com',
  REACT_APP_LINKEDIN_CLIENT_ID: '86trxag8iot3qe',
  REACT_APP_LINKEDIN_SCOPE: 'r_emailaddress r_liteprofile',
  REACT_APP_PRECISA_EDIT_REPORT_HEADER: true,
  REACT_APP_PRECISA_REPORT_SETTING_TAB: true,
  REACT_APP_BROWSER_TAB_NAME_FOR_ANALYSIS: 'Precisa - Analysis',
  REACT_APP_AVAILABLE_BALANCE_FILTER: true,
  REACT_APP_DOWNLOAD_CAM_BUTTON_REPORT: true,
  REACT_APP_NEW_REPORT_BUTTON: true,
  REACT_APP_REPORT_REFERESH_BUTTON: true,
  REACT_APP_REPORT_DELETE_BUTTON: true,
  REACT_APP_FILE_SIZE: 50000,
  REACT_APP_FILE_COUNT: 25,
  REACT_APP_DISABLE_FILE_DROPZONE: false,
  REACT_APP_CAPTCHA_VIEW: false,
  REACT_APP_DISCOUNT_PERCENT: 10,
  REACT_APP_DISCOUNT_PERCENT_BUNDLE_OF_FIVE: 5
};

const configSingletonInstance = new ConfigSingleton(initialData);
export default configSingletonInstance;
